let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6Nh0d")).then(() => parcelRequire('41bOz'));